module.exports = __webpack_public_path__ + "static/media/kettle.21bc7407.png";